const actions = {
  async handleCreateSpace({dispatch}, [name, primaryColour]) {
    let res = await dispatch('api/nav/createSpace', {
      name,
      primaryColour
    })

    if (res?.success) {
      dispatch('analytics/createSpace', ['Create Space Finalised', 'final', {...res.success}])
    } else {
      dispatch('popups/nav/errorCreatingArea')
    }

    return res
  },
};

export default {
  actions
};
